import {
  ApplicationConfig,
  APP_INITIALIZER,
  importProvidersFrom,
  LOCALE_ID
} from '@angular/core';
import { provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withDebugTracing } from '@angular/router';
import {
  provideHttpClient,
  withInterceptors
} from '@angular/common/http';

import { routes } from './app.routes';
import { AppConfigService } from './shared/services/app.config.service';
import { authInterceptor } from './auth/auth.interceptor';
import { provideNativeDateAdapter } from '@angular/material/core';

import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';

// ngx-translate imports
import { HttpClient } from '@angular/common/http';
import {
  TranslateModule,
  TranslateLoader
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideAnimations } from '@angular/platform-browser/animations';
import { LanguageService } from './shared/services/language/language.service';
import { ThemeService } from './shared/services/theme/theme.service';
import localePt from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localePt);

// Função para inicializar configurações da aplicação
export function initializeAppConfig(appConfig: AppConfigService) {
  return () => appConfig.load();
}

// Função que cria o loader de tradução
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideNativeDateAdapter(),
    provideAnimations(),
    provideLottieOptions({
      player: () => player,
    }),
    {provide: LOCALE_ID, useValue: 'pt-BR'},
    provideHttpClient(withInterceptors([authInterceptor])),
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppConfig,
      deps: [AppConfigService, LanguageService, ThemeService],
      multi: true
    },
    // Tradução (ngx-translate)
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'pt',
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient]
        }
      })
    )
  ]
};
